import type { TypographyProps } from '@mui/material';
import { Typography as MuiTypography } from '@mui/material';
import { typographyClassNames } from '../theme/generated/typography';
import clsx from 'clsx';
import { TypographyTypeMap } from '@mui/material/Typography/Typography';
import { ElementType } from 'react';
import { tokens } from '../theme/generated/tokens';
import { dsPaletteDefaults } from '../theme/cssVars';

export type { TypographyProps } from '@mui/material';

const secondaryColors = [
  'textSecondary',
  'grey.500',
  'grey.400',
  dsPaletteDefaults.grey[500],
  dsPaletteDefaults.grey[400],
];

const primaryColors = [
  'primary',
  'textPrimary',
  'grey.900',
  dsPaletteDefaults.grey[900],
];

export const Typography = (<
  C extends ElementType = TypographyTypeMap['defaultComponent']
>({
  variant,
  className,
  color,
  ...rest
}: TypographyProps<C>) => {
  return (
    <MuiTypography
      className={clsx(
        className,
        !!variant &&
          typographyClassNames[variant as keyof typeof typographyClassNames]
      )}
      variant={variant}
      color={(() => {
        if (color) {
          if (primaryColors.includes(color as string)) {
            return tokens.theme.fg.structural.primary;
          }
          if (secondaryColors.includes(color as string)) {
            return tokens.theme.fg.structural.secondary;
          }
        }
        return color;
      })()}
      {...rest}
    />
  );
}) as typeof MuiTypography;
